import { useState, useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';

export const useDebounce = (initialValue = '', delay = 500, onDebouncedChange) => {
  const [inputValue, setInputValue] = useState(initialValue);
  const [debouncedValue, setDebouncedValue] = useState(initialValue);

  const debouncedFn = useRef(
    debounce((value) => {
      setDebouncedValue(value);
      if (onDebouncedChange) {
        onDebouncedChange(value);
      }
    }, delay)
  ).current;

  useEffect(() => {
    debouncedFn(inputValue);
    return () => debouncedFn.cancel();
  }, [inputValue, debouncedFn]);

  return [inputValue, setInputValue, debouncedValue];
};
